'use client';

import { ErrorBoundary } from '@sentry/nextjs';

import {
  GameResultsTable,
  GameResultsTableProps,
} from '@/modules/players/v2/tabs/rating-history/components/DuprRatingComponents/GameResultsTable';

export const GameResultsWrapperTable = ({ matches }: GameResultsTableProps) => {
  return (
    <ErrorBoundary
      fallback={
        <div className='mt-4 border-t border-gray-200 px-3 py-6 text-center'>
          Oops! We&apos;re having trouble loading the game results right now. Please try again
          later.
        </div>
      }
    >
      <GameResultsTable matches={matches} />
    </ErrorBoundary>
  );
};
